const FinalCTA = () => (
  <section id="cta" className="relative pt-16 pb-24 sm:pt-20 sm:pb-32">
    <div className="relative max-w-3xl mx-auto px-5 sm:px-6 text-center">
      <div>
        <p className="text-[10px] uppercase tracking-[0.18em] text-muted-foreground font-mono mb-4">
          Get started
        </p>
        <h2 className="h-display text-foreground max-w-[18ch] mx-auto">
          Hire your first <em>AI worker.</em>
        </h2>
        <p className="mt-5 text-[15px] sm:text-[16px] text-muted-foreground leading-[1.55] max-w-[58ch] mx-auto">
          One system, every role. Mane agents remember context, hand off work cleanly, and get sharper with every job. Start with one, or scale to a full team.
        </p>
        <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a href="/get-mane" className="btn-pill btn-primary">
            Get Started
          </a>
          <a href="/architecture" className="btn-pill btn-secondary">
            Read the Docs
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default FinalCTA;

